import { Divider, Flex, Radio, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { PaymentMethodRadioProps, RadioGroupInjectedProps } from "./types";

export const PaymentMethodRadio = ({
  label,
  value,
  toPayToday,
  installment,
  total,
  isCombined = false,
  ...radioProps
}: PaymentMethodRadioProps & RadioGroupInjectedProps) => {
  return (
    <Radio data-testid={value} value={value} label={label} {...radioProps}>
      <Flex
        className={classNames("mobius-payment-method-radio__wrapper", {
          "mobius-payment-method-radio__wrapper--combined": isCombined,
        })}
      >
        <Flex className="mobius-payment-method-radio__row">
          <Text
            variant="small"
            className="mobius-payment-method-radio__text--bold"
          >
            To pay today
          </Text>
          <Text
            variant="small"
            className="mobius-payment-method-radio__text--bold"
          >
            {toPayToday}
          </Text>
        </Flex>
        {installment && (
          <>
            <Flex className="mobius-payment-method-radio__row mobius-payment-method-radio__installment-row">
              <Text variant="small">{installment.label}</Text>
              <Text variant="small">{installment.amount}</Text>
            </Flex>
            <Divider />
            <Flex className="mobius-payment-method-radio__row">
              <Text variant="small">Total</Text>
              <Text
                variant="small"
                className="mobius-payment-method-radio__text--bold"
              >
                {total}
              </Text>
            </Flex>
          </>
        )}
      </Flex>
    </Radio>
  );
};

PaymentMethodRadio.displayName = "PaymentMethodRadio";
